var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_3058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0C12.4923 0 8.16531 1.79217 4.98047 4.97914C1.79234 8.16737 0.000883123 12.4912 0 17C0 21.5069 1.79297 25.8339 4.98047 29.0209C8.16531 32.2078 12.4923 34 17 34C21.5077 34 25.8347 32.2078 29.0195 29.0209C32.207 25.8339 34 21.5069 34 17C34 12.4931 32.207 8.16611 29.0195 4.97914C25.8347 1.79217 21.5077 0 17 0Z",
    fill: "url(#paint0_linear_59_3058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69471 16.8204C12.6513 14.6614 15.9556 13.238 17.6078 12.5502C22.3306 10.5865 23.3108 10.2454 23.951 10.2339C24.0917 10.2316 24.4052 10.2664 24.6097 10.4318C24.7797 10.5712 24.8275 10.7598 24.8514 10.8922C24.8727 11.0245 24.9019 11.326 24.878 11.5613C24.623 14.2495 23.5153 20.7727 22.9522 23.7835C22.7158 25.0575 22.2456 25.4846 21.7914 25.5263C20.8033 25.6171 20.0542 24.8739 19.098 24.2473C17.6025 23.2664 16.7578 22.656 15.3049 21.6989C13.6261 20.5928 14.7152 19.9848 15.6714 18.9914C15.9211 18.7313 20.2721 14.7749 20.3544 14.416C20.365 14.3711 20.3756 14.2038 20.2747 14.1156C20.1764 14.0271 20.0303 14.0574 19.9241 14.0813C19.7727 14.1153 17.3847 15.6952 12.7522 18.8209C12.0749 19.2868 11.4613 19.5139 10.9088 19.5019C10.3031 19.4889 9.13439 19.1587 8.2658 18.8766C7.2033 18.5305 6.35595 18.3475 6.43033 17.7597C6.46752 17.4537 6.88986 17.1405 7.69471 16.8204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_3058",
    x1: 1700,
    y1: 0,
    x2: 1700,
    y2: 3400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.57b07d5e2c5186e36954b03b6dd1b291.svg";
export { ForwardRef as ReactComponent };